import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import {
  reduxForm, change, getFormValues, reset, getFormInitialValues, SubmissionError, getFormSyncErrors,
} from 'redux-form';
import { t } from 'i18next';
import Modal from 'react-modal';
import { Beforeunload } from 'react-beforeunload';
import embargoErrorMessageUpdated from '../../utils/embargoErrorMessageUpdated';
import FormProgressBar from '../ReactComponent/FormProgressBar';
import SignupBanner from '../ReactComponent/SignupBanner';
import {
  putReduxServiceLevelApproved,
  putReduxServiceLevelQuotes,
  putReduxServiceLevelCode,
  addPageLoader,
  removePageLoader,
} from './actions';
import { endpoints, routes, formNames } from '../../utils/constants';
import NextPreviousButtons from '../../lib/ui/form_elements/NextPreviousButtons';
import {
  getAddress,
  getZip,
  getCity,
  getState,
  getCountry,
  scrollToTop,
  checkBillToAccountProtectedStatus,
  getCountryFromZip,
  isCanadianAddress,
  serviceLevelCodeSelection,
} from '../../utils/func';
import {
  measurementValidate, listCompleted, isUSZip, isCANPostal,
} from '../../utils/validator';
import { digitOnly, phoneNumber } from '../../utils/mask';
import handleDeliveryType from '../../utils/deliveryAddress';
import {
  QuoteTypes,
  DeliveryTypes,
  PrefillNumberTypes,
  AddressTypes,
  ShipmentTypes,
  Divisions,
  PaymentMethods,
  SamedayServiceType,
  CommerceServiceType,
  IsYesOrNo,
  SamedayShipmentType,
  QuoteStatuses,
  UnitType,
} from '../../utils/enums';
import { FormContainer, CanRateLinkWrapper } from './css';
import Step1 from './steps/Step1';
import Step2 from './steps/Step2/index';
import Step3 from './steps/Step3/index';
import Step4 from './steps/Step4';
import Step5 from './steps/Step5';
import QuestionsBlock from '../ReactComponent/QuestionsBlock';
import ModalBoxStyle from '../_styledComponents/ModalBoxStyle';
import { apiCreateQuote } from '../../services/quotes';
import { apiDownloadQuoteReport } from '../../services/documents';
import { apiGetRates, apiDuplicateByBillNumber } from '../../services/orders';
import { list as unitsList } from '../ReactComponent/Measurement/Units/utils';
import { validateTariffZone } from '../../services/tariffService';
import { getPreferences } from '../../services/users';
import { getCompaniesList } from '../../services/companies';
import { getCompanyContacts } from '../../services/contacts';
import { putReduxAllCompanies } from '../ManageCompanies/actions';
import putReduxAllContacts from '../ManageContacts/actions';
import utils from '../../utils/utils';
import mock from './mock.json';
import formApiToData from '../../utils/apiMapping';
import CreateQuoteModals from './Modals/CreateQuoteModals';
import { initAccessorialsForm } from '../../lib/ui/accessorialsPicker/methods';
import { addressValidation } from '../../utils/addressValidation';
import apiDBErrorMessage from '../../utils/apiDBErrorMessage';

export const getTotalWeight = (list = []) => list.map((item) => item.itemWeight).reduce((accum, curr) => Number(accum) + Number(curr), 0);

const formName = formNames.createQuote;
let serviceLevels = '';

const initialValues = {
  division: Divisions.Freight.name,
  deliveryType: { name: DeliveryTypes.Commercial, desc: 'CommercialServiceDesc' },
  measurementType: unitsList[0],
  dangerDisable: false,
  measurementList: [{}],
  commodityType: '',
  selectedUnits: '',
  regularScheduledPickup: { name: IsYesOrNo.No, value: false },
  accessByTrailer: { name: IsYesOrNo.Yes, value: true },
  createBillOfLading: true,
  numberTypeSelected: {
    name: 'None',
    value: 'none',
  },
  broker: {
    name: '',
    emailAddress: '',
    phoneNumber: '',
  },
  shipmentType: SamedayShipmentType.Regular,
  isShipperAddressCanadaPost: false,
  isConsigneeAddressCanadaPost: false,
  quoteType: { name: QuoteTypes.Domestic, desc: 'DomesticQuoteDesc' },
  userAddressType: AddressTypes.SHIPPER,
  paymentMethod: { name: PaymentMethods.Prepaid, desc: 'PrepaidDesc' },
  accessorials: {},
  isNonServiceableLocation: false,
  isWinterNonServiceableLocation: false,
};
class CreateQuoteForm extends PureComponent {
  constructor(props) {
    super(props);
    const { fields } = utils.isDisconnected ? mock : props;

    this.steps = [
      fields.data.datasource.step1Title.value || 'step1Title',
      fields.data.datasource.step2Title.value || 'step2Title',
      fields.data.datasource.step3Title.value || 'step3Title',
      fields.data.datasource.step4Title.value || 'step4Title',
      fields.data.datasource.step5Title.value || 'step5Title',
    ];
    this.state = {
      currentStep: 0,
      lastStep: 3,
      reviewStep: 4,
      accessorialsBase: [],
      services: null,
      data: {},
      modalIsOpen: false,
      errorType: null,
      errorMessage: '',
      accList: [],
      submitFailure: false,
      isProtectedAccount: false,
      isManageContactPermission: false,
      embargoErrorMessage: false,
      isEmbargoErrorMessageUpdated: false,
      getRatesError: false,
      resubmit: false,
      createQuoteData: {},
      createQuoteFlag: false,
      isWindows: false,
    };
    this.addressFieldsRef = React.createRef();
  }

  componentDidMount() {
    const {
      isAuthenticated, dispatch, division, userEmail, userId, formData, billingAccounts, fields,
    } = this.props;

    const isWindows = typeof navigator !== 'undefined'
        && navigator.platform
        && navigator.platform.toLowerCase().includes('win');

    this.setState({ isWindows });

    dispatch(change(formName, 'selectedUnits', t(UnitType.Imperial)));
    dispatch(change(formName, 'isQuote', true));
    if (isAuthenticated) {
      dispatch(change(formName, 'quoteDest', userEmail));
    }

    this.setInitialPaymentMethod();
    let urlParams;
    if (typeof window !== 'undefined') {
      urlParams = new URLSearchParams(window.location.search);
      const divisionQueryParam = urlParams.get('division');
      if (divisionQueryParam) {
        dispatch(change(formName, 'division', divisionQueryParam));
      } else if (isAuthenticated) {
        // Get value from store, which was populated from storage...
        dispatch(change(formName, 'division', division));
      }

      // Handle with queryString requests. eg. recreate, based on an existing quote, etc
      this.handleQueryStringRequests();

      const accessorials = utils.isDisconnected ? mock.fields.data.accessorialsItem : fields.data.accessorialsItem;
      initAccessorialsForm(accessorials, formName, dispatch);
    }

    if (isAuthenticated) {
      checkBillToAccountProtectedStatus(dispatch, division, userId, billingAccounts);
      const USQuote = (formData && formData.quoteType && formData.quoteType.name === QuoteTypes.USQuote);
      if (USQuote) {
        this.getUSQuoteDetails(userId);
      } else {
        this.getUserPrefSamedayDetails(userId);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formData !== this.props.formData && this.state.resubmit) {
      this.resubmit();
    }

    serviceLevels = serviceLevelCodeSelection(this.props.formData);
  }

  handleQueryStringRequests = () => {
    const { dispatch } = this.props;
    const urlParams = new URLSearchParams(window.location.search);

    // Get data from a provided quoteNumber
    if (urlParams.get('quoteNumber')) {
      const quoteNumber = urlParams.get('quoteNumber');
      dispatch(change(formName, 'numberTypeSelected', { name: 'Use Quote Number', value: PrefillNumberTypes.quote }));
      dispatch(change(formName, 'quoteOrShipmentNumber', quoteNumber));

      if (urlParams.get('resubmit')) {
        const callback = () => {
          this.setState({ resubmit: true });
        };

        this.populateFormBasedOnAnExistingQuoteOrShipment('resubmit', quoteNumber, callback);
      } else {
        this.populateFormBasedOnAnExistingQuoteOrShipment('duplicate', quoteNumber);
      }
    }
  };

  handleCreateByNumberError = (type) => {
    const { dispatch } = this.props;
    switch (type) {
      case QuoteStatuses.UnderReview:
        this.setState({ errorType: null, errorMessage: t('QuoteUnderReview') });
        break;
      case QuoteStatuses.USQuote:
        this.setState({ errorType: null, errorMessage: t('UsQuoteNumberError') });
        break;
      case endpoints.shipping.quotes:
        this.setState({ errorType: 'Invalid Quote Number', errorMessage: t('Invalid quote number, please enter another number') });
        break;
      case endpoints.shipping.shipments:
        this.setState({ errorType: null, errorMessage: t('Invalid shipment number, please enter another number') });
        break;
      default:
        break;
    }

    this.setState({ modalIsOpen: true });
    dispatch(change(formName, 'quoteOrShipmentNumber', ''));
  };

  getRatesErrorHandling = (error) => {
    const { errorMessage } = embargoErrorMessageUpdated(error);
    const { isEmbargoErrorMessageUpdated } = embargoErrorMessageUpdated(error);
    this.setState({
      modalIsOpen: true, errorMessage, getRatesError: true, isEmbargoErrorMessageUpdated,
    });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  getRates = () => {
    const {
      serviceLevelCode, formData, userId, userEmail,
    } = this.props;

    const callback = () => {
      setTimeout(() => scrollToTop(), 200);
    };

    apiGetRates({
      putReduxServiceLevelQuotes,
      putReduxServiceLevelCode,
      putReduxServiceLevelApproved,
      serviceLevelCode,
      formData,
      userId,
      userEmail,
      prevStep: 3,
      errorHandle: this.getRatesErrorHandling,
      isQuoteForm: true,
    }).then(
      this.setState({ currentStep: 4 }, callback),
    );
  };

  getUSQuoteDetails(userId) {
    const { division } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const dontUsePref = !!((urlParams.get('quoteNumber') || urlParams.get('shipmentId') || urlParams.get('probillNumber')));

    getPreferences(userId, division).then((response) => {
      if (response.data) {
        const { data } = response;
        this.formUserPrefUSQuoteApiValueToData(data);
        // Don't apply user preferences state when loading from an existing quote/shipment
        if (!dontUsePref) {
          this.setState({ ...data });
        }
      }
    });
  }

  getUserPrefSamedayDetails(userId) {
    const { division } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const dontUsePref = !!((urlParams.get('quoteNumber') || urlParams.get('shipmentId') || urlParams.get('probillNumber')));

    getPreferences(userId, division).then((response) => {
      if (response.data) {
        const { data } = response;
        this.formUserPrefApiValueToData(data);
        // Don't apply user preferences state when loading from an existing quote/shipment
        if (!dontUsePref) {
          this.setState({ ...data });
        }
      }
    });
  }

  formUserPrefApiValueToData = (data) => {
    const { dispatch, division } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const dontUsePref = !!((urlParams.get('quoteNumber') || urlParams.get('shipmentId') || urlParams.get('probillNumber')));
    const { serviceType } = data;
    return {
      ...data,
      fromContactId: dontUsePref ? undefined : data.fromContactId,
      toContactId: dontUsePref ? undefined : data.toContactId,
      billTo: dontUsePref ? undefined : dispatch(change(formName, 'billTo', data.billToAccountNumber?.accountNumber || data.billToAccountNumber)),
      deliveryType: (division === Divisions.Sameday.name) ? this.setDeliveryType(serviceType) : undefined,
    };
  };

  dispatchFormValues = (data, callback) => {
    const { dispatch, removePageLoader, userEmail } = this.props;
    const { serviceType, paymentMethod } = data;

    Object.keys(data).map((field) => !(field === 'paymentMethod' || field === 'serviceType') && dispatch(change(formName, field, data[field])));

    dispatch(change(formName, 'quoteDest', userEmail));

    if (serviceType) this.setDeliveryType(serviceType);
    if (paymentMethod) this.setPaymentMethod(paymentMethod);

    if (callback) {
      callback();
    } else {
      removePageLoader();
    }
  };

  updateState = (name, value, callback) => this.setState({ [name]: value }, callback);

  resubmit = async () => {
    const { data } = this.state;
    const { serviceLevelCode } = data;
    const {
      formData,
      userId,
      userEmail,
      userName,
      removePageLoader,
      isAuthenticated,
    } = this.props;

    const callback = () => {
      this.setState({ currentStep: 4, resubmit: false }, removePageLoader);
    };

    const { updateState } = this;

    // Fix Country codes
    formData.shipperCountry = getCountry(formData.shipperCountry);
    formData.consigneeCountry = getCountry(formData.consigneeCountry);

    await apiCreateQuote(formData, serviceLevelCode, userId, userEmail, userName, isAuthenticated, updateState, callback)
      .catch((error) => {
        const errorMessage = error?.errors?.message ? apiDBErrorMessage(error.errors.message) : null;
        this.setState({
          modalIsOpen: true, errorMessage: errorMessage || t('ErrorMessage'), getRatesError: true, createQuoteFlag: true,
        });
        removePageLoader();
      });
  };

  populateFormBasedOnAnExistingQuoteOrShipment = async (type, code, callback) => {
    const { preExistingValuesExist } = this.state;
    const { formData, addPageLoader, removePageLoader } = this.props;
    const codeByQueryString = code;
    const codeByForm = formData && formData.quoteOrShipmentNumber;
    const quoteOrShipmentNumber = (code) ? codeByQueryString : codeByForm;

    addPageLoader();

    if (!quoteOrShipmentNumber) {
      return;
    }

    if (preExistingValuesExist) {
      return;
    }

    try {
      const { dispatch } = this.props;
      const response = (quoteOrShipmentNumber) ? await apiDuplicateByBillNumber(quoteOrShipmentNumber) : null;

      if (response && response.data) {
        dispatch(change(formName, 'selectedUnits', response.data.measurementType === 1 ? t(UnitType.Imperial) : t(UnitType.Metric)));
        dispatch(change(formName, 'measurementType', unitsList[1 - response.data.measurementType]));
      }

      if (response && response.data) {
        const { data } = response;
        if (data.shipmentItems && !data.items) {
          data.items = data.shipmentItems;
        }

        if (response.data.underReview) {
          removePageLoader();
          this.handleCreateByNumberError(endpoints.shipping.quotes);
        } else {
          this.fillFormWithExistingData(data, callback);
        }
      }
    } catch (error) {
      removePageLoader();
      this.handleCreateByNumberError(endpoints.shipping.quotes);
    }
  };

  fillFormWithExistingData = (data, callback) => {
    const { fields, formData } = this.props;
    const { accessorials } = formData;
    const commodities = utils.isDisconnected ? mock.fields.data.commoditiesItem : fields.data.commoditiesItem;

    data.accList = accessorials;

    // Join commodities in an only one level
    const commoditiesList = [];
    commodities.children.forEach((child) => {
      child.children.forEach((item) => {
        commoditiesList.push({
          code: item.code.value.toUpperCase(),
          name: item.description.value.toLowerCase(),
          isDangerous: item.dangerous.value,
        });
      });
    });

    const updatedItems = [];
    if (data.items) {
      data.items.forEach((item) => {
        const updatedItem = { ...item };
        if (item.commodityType) {
          const obj = commoditiesList.filter((commodity) => commodity.code === item.commodityType)[0];
          updatedItem.commodityType = { code: obj.code, name: obj.name };
        }

        updatedItems.push(updatedItem);
      });

      data.items = updatedItems;
    }

    const updatedFormData = formApiToData(data);

    this.setState({
      data: updatedFormData,
      errorMessage: null,
      preExistingValuesExist: true,
    }, () => { this.dispatchFormValues(updatedFormData, callback); });
  };

  setInitialPaymentMethod = () => {
    const { dispatch, isAuthenticated } = this.props;
    if (isAuthenticated) {
      dispatch(change(formName, 'paymentMethod', PaymentMethods.Other));
    } else {
      dispatch(change(formName, 'paymentMethod', PaymentMethods.CreditCard));
    }
  };

  setPaymentMethod = (paymentMethod) => {
    const { dispatch } = this.props;
    let newPaymentMethod;

    if (paymentMethod === PaymentMethods.Collect) {
      newPaymentMethod = {
        name: PaymentMethods.Collect,
        desc:
          'CollectDesc',
      };
    }

    if (paymentMethod === PaymentMethods.Prepaid) {
      newPaymentMethod = {
        name: PaymentMethods.Prepaid,
        desc:
          'PrepaidDesc',
      };
    }

    if (paymentMethod === PaymentMethods.ThirdParty) {
      newPaymentMethod = {
        name: PaymentMethods.ThirdParty,
        desc:
          'ThirdPartyDesc',
      };
    }

    dispatch(change(formName, 'paymentMethod', newPaymentMethod));
  };

  setDeliveryType = (serviceType) => {
    const { dispatch } = this.props;
    let newDeliveryType;

    if (serviceType === SamedayServiceType.Commercial) {
      newDeliveryType = { name: DeliveryTypes.Commercial, desc: 'CommercialServiceDesc' };
    }

    if (serviceType === SamedayServiceType.Residential || serviceType === CommerceServiceType.Residential) {
      newDeliveryType = { name: DeliveryTypes.Residential, desc: 'ResidentialServiceDesc' };
    }

    dispatch(change(formName, 'deliveryType', newDeliveryType));
  };

  formUserPrefUSQuoteApiValueToData = (data) => {
    const { dispatch, division } = this.props;
    const urlParams = new URLSearchParams(window.location.search);
    const dontUsePref = !!((urlParams.get('quoteNumber') || urlParams.get('shipmentId') || urlParams.get('probillNumber')));

    // Don't apply user preferences when loading from an existing quote/shipment
    if (dontUsePref) {
      return data;
    }

    const {
      shipperName,
      shipperPostalCode,
      consigneePostalCode,
      billToAccountNumber,
    } = data;
    const { accountNumber } = billToAccountNumber || {};
    if (billToAccountNumber) this.getFuelSurcharges(division, accountNumber || billToAccountNumber);

    return {
      ...data,
      billTo: dispatch(change(formName, 'billTo', accountNumber || billToAccountNumber)),
      shipperContactName: dispatch(change(formName, 'shipperContactName', shipperName)),
      shipperAddress: dispatch(change(formName, 'shipperAddress', shipperPostalCode)),
      consigneeAddress: dispatch(change(formName, 'consigneeAddress', consigneePostalCode)),
    };
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  formApiToData = (rawData) => {
    const {
      division,
      paymentType,
      from,
      to,
      items,
      measurementType,
      billToAccountNumber,
      quoteEmail,
      accessorials,
      accList,
      serviceType,
      expiryDate,
      totalAmount,
      serviceLevelCode,
      serviceLevelDescription,
      emailAddress,
    } = rawData;
    const shipperAddress = `${from.address1}, ${from.city}, ${from.provinceCode} ${from.postalCode}, ${from.countryCode}`;
    const consigneeAddress = `${to.address1}, ${to.city}, ${to.provinceCode} ${to.postalCode}, ${to.countryCode}`;

    const measurementList = items.map((each) => ({
      itemWeight: each.weight,
      itemLength: each.length,
      itemWidth: each.width,
      itemHeight: each.height,
      SkidQty: each.pallets,
      PieceQty: each.pieces,
      itemDescription: each.description,
      itemWeightUnit: each.weightUnitType,
      itemLengthUnitType: each.lengthUnitType,
      completed: true,
    }));
    const accCodesList = accessorials.map((a) => a.code.trim());
    const accessorialsList = accList ? accList
      .filter((each) => accCodesList.includes(each.code))
      .map((each) => {
        const accessorialFromBackend = accessorials.find((a) => a.code === each.code);
        return {
          [each.code]: {
            selected: ['',
              {
                name: each.description,
                code: each.code,
                accessorialId: each.accessorialId,
              }],
            value: accessorialFromBackend.amount && accessorialFromBackend.amount.value,
            currency: accessorialFromBackend.amount && accessorialFromBackend.amount.currencyCode,
          },
        };
      })
      .reduce((curr, accum) => ({ ...accum, ...curr }), {}) : '';
    return {
      division,
      paymentMethod: paymentType,

      shipperCompanyName: from.companyName,
      shipperContactName: from.contactName,
      shipperAddress,
      shipperAddressAdditional: from.address2,
      shipperEmail: from.contactEmail,
      shipperPhoneNumber: from.contactPhoneNumber && phoneNumber(from.contactPhoneNumber),
      shipperPhoneNumberExt: from.contactPhoneNumberExt,

      consigneeCompanyName: to.companyName,
      consigneeContactName: to.contactName,
      consigneeAddress,
      consigneeAddressAdditional: to.address2,
      consigneeEmail: to.contactEmail,
      consigneePhoneNumber: to.contactPhoneNumber && phoneNumber(to.contactPhoneNumber),
      consigneePhoneNumberExt: to.contactPhoneNumberExt,

      accessorials: accessorialsList,
      measurementList,
      measurementType: unitsList.find((mt) => mt.value === measurementType),
      billTo: billToAccountNumber?.accountNumber || billToAccountNumber,
      quoteDest: quoteEmail || emailAddress,
      serviceType,
      expiryDate,
      totalAmount: totalAmount && totalAmount.value ? totalAmount.value : 0,
      serviceLevelCode,
      serviceLevelDescription,
    };
  };

  getFuelSurcharges = (division, billTo) => {
    axios.get(`${t('ApiEndPoint')}${t('ShippingApiVirtualFolder')}${endpoints.shipping.tariffs}/${division}/discount`,
      {
        headers:
        {
          accountNumber: billTo,
        },
      }).then((res) => {
      if (res.status === 200) {
        this.updateState('tariffOptions', res.data);
        const { formData: { tariffSurcharge }, dispatch } = this.props;
        if (!tariffSurcharge) {
          dispatch(change(formName, 'tariffSurcharge', res.data[0]));
        }
      }
    });
  };

  nextStep = async (e) => {
    e?.preventDefault();

    const {
      formData,
      formData: {
        measurementList, quoteType, billTo, usFromAddress, usToAddress, tariffSurcharge,
      },
      valid,
      dispatch,
      isAuthenticated,
      userId,
      userEmail,
      userName,
      serviceLevelCode,
      putReduxServiceLevelQuotes,
      putReduxServiceLevelCode,
      putReduxServiceLevelApproved,
    } = this.props;

    const {
      currentStep, accList, isProtectedAccount, isNonServiceableLocation,
    } = this.state;
    const hasMeasureMents = currentStep !== 1 ? true : !!measurementList;
    const USQuote = quoteType && quoteType.name === QuoteTypes.USQuote;

    if (valid && hasMeasureMents) {
      if (currentStep === 0
        && (t('EmbargoFlag') === 'ON')
        && ((formData.shipperAddress && formData.shipperAddress.includes('BC'))
        || (formData.consigneeAddress && formData.consigneeAddress.includes('BC')))) {
        const errorMessage = t('EmbargoWarning');
        this.setState({ modalIsOpen: true, errorMessage, embargoErrorMessage: true });
      }

      if (currentStep === 0) {
        if (!formData.consigneeCountry) {
          dispatch(change(formName, 'consigneeCountry', getCountryFromZip(formData.consigneePostalZipCode)));
        }

        if (!isProtectedAccount && !isNonServiceableLocation) {
          if (USQuote) {
            if (t('EmbargoFlag') === 'ON') {
              if (
                (formData.consigneeAddress && formData.consigneeAddress.toLowerCase().charAt(0) === ('V').toLowerCase())
                || (formData.shipperAddress && formData.shipperAddress.toLowerCase().charAt(0) === ('V').toLowerCase())
              ) {
                const errorMessage = t('EmbargoWarning');
                this.setState({ modalIsOpen: true, errorMessage, embargoErrorMessage: true });
              }
            }

            validateTariffZone({
              accountNumber: isAuthenticated ? billTo : '999998',
              fromPostalCode: (usFromAddress === undefined) ? formData.shipperAddress : (usFromAddress && usFromAddress.postalCode) || usFromAddress,
              toPostalCode: (usToAddress === undefined) ? formData.consigneeAddress : (usToAddress && usToAddress.postalCode) || usToAddress,
              originZone: tariffSurcharge && tariffSurcharge.origin,
              destinationZone: tariffSurcharge && tariffSurcharge.destination,
            }).then((res) => {
              if (!res.data) {
                const errorMessage = t('IncorrectTariffZone');
                this.setState({ modalIsOpen: true, errorMessage });
                return;
              }

              this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
                setTimeout(() => scrollToTop(), 200);
              });
            });
          } else {
            this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
              setTimeout(() => scrollToTop(), 200);
            });
          }
        }

        dispatch(change(formName, ShipmentTypes.US_SHIPMENT, USQuote));

        const USShipment = (isCANPostal(formData.shipperPostalZipCode)
        && isUSZip(formData.consigneePostalZipCode)) || (isUSZip(formData.shipperPostalZipCode) && isCANPostal(formData.consigneePostalZipCode));
        dispatch(change(formName, 'USShipment', USShipment));
      }

      if (currentStep === 1) {
        if (!listCompleted(measurementList)) {
          return;
        }

        if (USQuote) {
          const adminSelected = [''].concat(accList.filter((acc) => acc.code === 'ADMIN')
            .map((acc) => ({ name: acc.description, code: acc.code, accessorialId: acc.accessorialId })));
          dispatch(change(formName, 'accessorials.ADMIN.selected', adminSelected));
        }

        this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
          setTimeout(() => scrollToTop(), 200);
        });
      }

      if (currentStep === 2) {
        apiGetRates({
          putReduxServiceLevelQuotes,
          putReduxServiceLevelCode,
          putReduxServiceLevelApproved,
          serviceLevelCode,
          formData,
          userId,
          userEmail,
          userName,
          prevStep: this.prevStep,
          errorHandle: this.getRatesErrorHandling,
          isQuoteForm: true,
          isAuthenticated,
        }).then(
          this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
            setTimeout(() => scrollToTop(), 200);
          }),
        );
      }
    }
  };

  prevStep = (e) => {
    e?.preventDefault();
    this.scrollToTop();
    this.setState((prevState) => ({ currentStep: prevState.currentStep - 1 }));
  };

  scrollToTop = () => window.scrollTo(0, 0);

  editStepOne = (e) => {
    e.preventDefault();
    this.setState({ currentStep: 0 });
  };

  editStepTwo = (e) => {
    e.preventDefault();
    this.setState({ currentStep: 1 });
  };

  editStepThree = (e) => {
    e.preventDefault();
    this.setState({ currentStep: 2 });
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  getServiceQuotes = (serviceLvlCode) => {
    const {
      isAuthenticated,
      putReduxServiceLevelQuotes,
      putReduxServiceLevelCode,
      fields,
      formData: {
        quoteType,
        usFromAddress,
        usToAddress,
        deliveryType,
        division,
        paymentMethod,
        shipperContactName,
        shipperCompanyName,
        shipperAddress,
        shipperAddressAdditional,
        shipperEmail,
        shipperPhoneNumber,
        shipperPhoneNumberExt,
        consigneeAddressAdditional,
        consigneeEmail,
        consigneePhoneNumber,
        consigneeAddress,
        consigneeContactName,
        consigneeCompanyName,
        consigneePhoneNumberExt,
        measurementType,
        measurementList,
        accessorials,
        quoteDest,
        tariffSurcharge,
        userAddressType,
        billTo,
      },
    } = this.props;
    const { currentStep } = this.state;

    const measurementLists = measurementList.map((each) => ({
      measurementType: measurementType.value,
      weight: each.itemWeight,
      length: each.itemLength,
      width: each.itemWidth,
      height: each.itemHeight,
      SkidQty: each.pallets,
      PieceQty: each.pieces,
      description: each.itemDescription,
      class: each.itemClass,
      isDangerousGoods: each.itemDangerous,
    }));

    const accessorialsLists = accessorials ? Object.values(accessorials).filter((acc) => acc.selected.length > 1).map((each) => {
      const { selected, value, currency } = each;
      if (value && currency) {
        return {
          accessorialId: selected[1].accessorialId ? selected[1].accessorialId : 1,
          code: selected[1].code,
          value: Number(value),
          currencyCode: currency,
        };
      }

      return {
        accessorialId: selected[1].accessorialId ? selected[1].accessorialId : 1,
        code: selected[1].code,
      };
    }) : '';

    const USQuote = quoteType && quoteType.name === QuoteTypes.USQuote;

    let shipperAddress1;
    let shipperCity;
    let shipperState;
    let shipperZip;
    let shipperCountry;

    let consigneeAddress1;
    let consigneeCity;
    let consigneeState;
    let consigneeZip;
    let consigneeCountry;

    if (USQuote) {
      shipperCity = usFromAddress.cityName;
      shipperState = usFromAddress.provinceCode;
      shipperZip = usFromAddress.postalCode;
      shipperCountry = usFromAddress.countryCode;

      consigneeCity = usToAddress.cityName;
      consigneeState = usToAddress.provinceCode;
      consigneeZip = usToAddress.postalCode;
      consigneeCountry = usToAddress.countryCode;
    } else {
      shipperAddress1 = getAddress(shipperAddress);
      shipperCity = getCity(shipperAddress);
      shipperState = getState(shipperAddress);
      shipperZip = getZip(shipperAddress);
      shipperCountry = getCountry(shipperAddress);

      consigneeAddress1 = getAddress(consigneeAddress);
      consigneeCity = getCity(consigneeAddress);
      consigneeState = getState(consigneeAddress);
      consigneeZip = getZip(consigneeAddress);
      consigneeCountry = getCountry(consigneeAddress);
    }

    const formValueToApi = {
      isGuestUser: !isAuthenticated,
      serviceLevelCode: serviceLvlCode,
      serviceType: (deliveryType && deliveryType.name === DeliveryTypes.Residential) ? SamedayServiceType.Residential : SamedayServiceType.Commercial,
      paymentType: (!USQuote && paymentMethod.name) ? paymentMethod.name.split(' ').join('') : undefined,
      language: 'EN',
      accountNumber: (this.props.isAuthenticated && billTo) || '',
      customerId: '176692', // tbr
      division,
      discountPercentage: (tariffSurcharge && tariffSurcharge.discountPercentage)
        ? tariffSurcharge.discountPercentage
        : undefined,
      minimumRateAmount: (tariffSurcharge && tariffSurcharge.minimumRateAmount && tariffSurcharge.minimumRateAmount.value)
        ? tariffSurcharge.minimumRateAmount.value
        : undefined,
      measurementType: measurementType.value,
      requestor: {
        companyName: shipperCompanyName,
        contactName: shipperContactName,
        address1: shipperAddress1,
        address2: shipperAddressAdditional,
        city: shipperCity,
        provinceCode: shipperState,
        countryCode: shipperCountry,
        postalCode: shipperZip,
        contactPhoneNumber: digitOnly(shipperPhoneNumber),
        contactPhoneNumberExt: shipperPhoneNumberExt,
        contactEmail: quoteDest,
      },
      from: {
        companyName: shipperCompanyName,
        contactName: shipperContactName,
        address1: shipperAddress1,
        address2: shipperAddressAdditional,
        city: shipperCity,
        provinceCode: shipperState,
        countryCode: shipperCountry,
        postalCode: shipperZip,
        contactPhoneNumber: digitOnly(shipperPhoneNumber),
        contactPhoneNumberExt: shipperPhoneNumberExt,
        contactEmail: shipperEmail,
      },
      to: {
        companyName: consigneeCompanyName,
        contactName: consigneeContactName,
        address1: consigneeAddress1,
        address2: consigneeAddressAdditional,
        city: consigneeCity,
        provinceCode: consigneeState,
        countryCode: consigneeCountry,
        postalCode: consigneeZip,
        contactPhoneNumber: digitOnly(consigneePhoneNumber),
        contactPhoneNumberExt: consigneePhoneNumberExt,
        contactEmail: consigneeEmail,
      },
      shipmentItems: [
        ...measurementLists,
      ],
      accessorials: [
        ...accessorialsLists,
      ],
    };
    if (serviceLvlCode || (currentStep === 3)) {
      formValueToApi.quoteEmail = quoteDest;
      formValueToApi.addressType = userAddressType;
      formValueToApi.createdBy = quoteDest;
      return axios.post(
        `${t('ApiEndPoint')}${t('ShippingApiVirtualFolder')}${USQuote ? endpoints.shipping.usQuote : endpoints.shipping.quotes}`,
        formValueToApi).then((res) => {
        if (res.status === 200 || res.status === 201) {
          if (USQuote) {
            this.setState((prevState) => ({
              data: {
                ...prevState.data,
                quoteNumber: res.data.quoteNumber,
              },
            }));
          } else if (res.data.exception === 'NullValueDatabaseError') {
            const errorMessage = t(fields.InsertTheValueNull.value);
            this.setState({
              modalIsOpen: true, errorMessage, submitFailure: true, currentStep: 0,
            });
            return;
          } else {
            this.setState({ data: res.data, submitFailure: false, currentStep: 4 });
          }

          this.scrollToTop();
        }
      }).catch(() => {
        throw new SubmissionError({});
      });
    }

    return axios.post(
      `${t('ApiEndPoint')}${t('ShippingApiVirtualFolder')}${USQuote ? endpoints.shipping.usQuoteRate : endpoints.shipping.serviceLevel}`,
      formValueToApi).then((res) => {
      if (res.status === 200) {
        if (USQuote) {
          this.setState({ data: res.data });
        } else {
          putReduxServiceLevelQuotes(res.data.serviceLevels);
          putReduxServiceLevelCode(handleDeliveryType(deliveryType, res));
        }
      }
    }).catch(() => {
      if (USQuote) {
        const errorMessage = t(fields.NonServiceableLocationError.value);
        this.setState({
          modalIsOpen: true, errorMessage, currentStep: 0, isNonServiceableLocation: true,
        });
      } else {
        if (division === Divisions.Sameday.name) {
          const errorMessage = t(fields.WinterNonServiceableLocationWarning.value);
          this.setState({
            modalIsOpen: true, errorMessage, currentStep: 0, isWinterNonServiceableLocation: true,
          });
        }

        this.prevStep();
      }
    });
  };

  createQuote = async (callback) => {
    const {
      serviceLevelCode,
      formData,
      userId,
      userEmail,
      userName,
      isAuthenticated,
      serviceLevelQuotes,
    } = this.props;

    const { updateState } = this;

    // Fix Country codes
    formData.shipperCountry = getCountry(formData.shipperCountry);
    formData.consigneeCountry = getCountry(formData.consigneeCountry);

    apiCreateQuote(formData, serviceLevelCode, userId, userEmail, userName, isAuthenticated, updateState, callback)
      .then((res) => {
        this.setState({ createQuoteData: res });
      })
      .catch((error) => {
        // Check if all services have $0 rates or are not approved
        const allServicesUnavailable = serviceLevelQuotes && serviceLevelQuotes.length > 0
          && serviceLevelQuotes.every((item) => {
            const totalAmountValue = (item.totalAmount && item.totalAmount.value) ? item.totalAmount.value : 0;
            return totalAmountValue === 0 || item.isApproved === false;
          });

        if (allServicesUnavailable) {
          // Don't show modal — proceed to Step5 where the review message will be displayed
          const selectedService = serviceLevelQuotes.find(
            (s) => s.serviceLevelCode === serviceLevelCode,
          ) || serviceLevelQuotes[0];

          this.setState({
            data: {
              totalAmount: { value: 0 },
              serviceLevelCode: selectedService?.serviceLevelCode,
              serviceLevelDescription: selectedService?.description,
              underReview: true,
            },
            createQuoteData: {
              totalAmount: { value: 0 },
              charges: [],
            },
            currentStep: 4,
          }, () => {
            this.scrollToTop();
          });
          removePageLoader();
          return;
        }

        const errorMessage = error?.errors?.message ? apiDBErrorMessage(error.errors.message) : null;
        this.setState({
          modalIsOpen: true, errorMessage: errorMessage || t('ErrorMessage'), getRatesError: true, createQuoteFlag: true,
        });
        removePageLoader();
      });
  };

  handleSubmit = async () => {
    const gotoLastStep = () => {
      const { currentStep } = this.state;
      const { formData } = this.props;
      const isBasedOnAnExistingQuoteOrOrder = (formData.quoteOrShipmentNumber);

      if (currentStep === 3 || isBasedOnAnExistingQuoteOrOrder) {
        this.scrollToTop();
        this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }), () => {
          setTimeout(() => scrollToTop(), 200);
        });
      }
    };

    await this.createQuote(gotoLastStep);
  };

  changeBillTo = (billTo) => {
    const {
      division, dispatch, formData, isAuthenticated,
    } = this.props;
    const { accountNumber } = billTo;
    const USQuote = formData && formData.quoteType && formData.quoteType.name === QuoteTypes.USQuote;
    dispatch(change(formName, 'tariffSurcharge', null));
    if (billTo.protected === true && isAuthenticated) {
      this.setState({ isProtectedAccount: true, modalIsOpen: true });
    } else {
      this.setState({ isProtectedAccount: false, modalIsOpen: false });
      if (USQuote) {
        this.getFuelSurcharges(division, accountNumber || billTo);
      }
    }
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  openModal = (newObj, obj, prevObj, fieldName) => {
    const {
      formData, initialValues, dispatch, userId, userEmail, division, isAuthenticated,
    } = this.props;
    this.setState({ fieldName, prevObj, newObj });
    const initialObjectValues = JSON.parse(JSON.stringify(initialValues));
    const fromObjectValues = JSON.parse(JSON.stringify(formData));

    delete initialObjectValues.deliveryType;
    delete initialObjectValues.quoteType;
    delete initialObjectValues.division;
    delete fromObjectValues.quoteType;
    delete fromObjectValues.deliveryType;
    delete fromObjectValues.tariffSurcharge;
    delete fromObjectValues.division;

    if (Object.keys(fromObjectValues).length > Object.keys(initialObjectValues).length) {
      this.setState({ modalIsOpen: true });
    } else {
      dispatch(reset(formName));
      if (isAuthenticated) {
        this.changeDivisionAndQuoteType(fieldName ? Divisions.Freight.name : newObj);
      } else {
        this.setState({ fieldName, prevObj, newObj }, this.changeUnAuthDivisionAndQuoteType(fieldName ? Divisions.Freight.name : newObj),
        );
      }

      dispatch(change(formName, 'quoteDest', userEmail));
      const DomesticQuote = (formData && formData.quoteType && formData.quoteType.name === QuoteTypes.Domestic);
      if (division === Divisions.Sameday.name || DomesticQuote) {
        this.getUserPrefSamedayDetails(userId);
      } else {
        this.getUSQuoteDetails(userId);
      }
    }
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
      fieldName: undefined,
      prevObj: undefined,
      newObj: undefined,
      errorMessage: undefined,
      isWinterNonServiceableLocation: false,
      embargoErrorMessage: false,
      isEmbargoErrorMessageUpdated: false,
    });
  };

  initialCalls = (division, userId) => {
    getCompaniesList(division, userId).then(
      (cl) => {
        const { putReduxAllCompanies, putReduxAllContacts } = this.props;
        putReduxAllCompanies(cl.data);
        this.fetchAllContacts(cl.data).then((res) => {
          const formedContactList = res;
          putReduxAllContacts(formedContactList);
        });
      },
    );
  };

  fetchAllContacts = (companies) => {
    if (companies) {
      return Promise.all(companies.map((comp) => getCompanyContacts(comp.companyId))).then((contactRequests) => {
        let allContacts = [];

        contactRequests.forEach((contactRequest) => {
          if (!contactRequest.data || contactRequest.data.length === 0) {
            return;
          }

          allContacts = allContacts.concat(contactRequest.data);
        });

        return allContacts;
      });
    }

    return undefined;
  };

  handleModalButtons = (event) => {
    event.preventDefault();
    const {
      dispatch, formData, userId, userEmail, division,
    } = this.props;
    const { fieldName, prevObj, newObj } = this.state;
    const {
      target: { name },
    } = event;

    if (name === 'continueButton') {
      dispatch(reset(formName));
      this.changeDivisionAndQuoteType(fieldName ? Divisions.Freight.name : newObj);
      dispatch(change(formName, 'quoteDest', userEmail));
      const USQuote = (formData && formData.quoteType && formData.quoteType.name === QuoteTypes.USQuote);
      if (USQuote) {
        this.getUSQuoteDetails(userId);
      } else {
        this.getUserPrefSamedayDetails(userId);
        this.initialCalls(division, userId);
      }
    } else if (name === 'cancelButton') {
      dispatch(change(formName, fieldName, prevObj));
    } else if (name === 'returnToStepOne') {
      this.setState({ currentStep: 0 });
    } else if (name === 'createANewQuote') {
      window.location.href = routes.createQuote;
    } else if (name === 'returnToStepTwo') {
      setTimeout(() => scrollToTop(), 200);
    }

    this.closeModal();
  };

  changeDivisionAndQuoteType = (division) => {
    const { dispatch, isAuthenticated, formData } = this.props;
    const { fieldName, newObj } = this.state;
    dispatch(change(formName, 'division', division));
    if (fieldName) {
      dispatch(change(formName, fieldName, newObj));
    }

    if (!isAuthenticated) {
      this.getFuelSurcharges(division, isAuthenticated && formData.billTo ? formData.billTo : '');
    }

    this.setInitialPaymentMethod();
  };

  changeUnAuthDivisionAndQuoteType = (division) => {
    const { dispatch, isAuthenticated, formData } = this.props;
    const { fieldName, newObj } = this.state;
    dispatch(change(formName, 'division', division));
    if (fieldName) {
      dispatch(change(formName, fieldName, newObj));
    }

    if (!isAuthenticated) {
      this.getFuelSurcharges(division, isAuthenticated && formData.billTo ? formData.billTo : '');
    }

    this.setInitialPaymentMethod();
  };

  handleShipNow = () => {
    const { formData } = this.props;
    const { data } = this.state;
    // eslint-disable-next-line max-len
    window.location.href = `${routes.createShipment}?division=${formData && formData.division}&quoteNumber=${data && data.quoteNumber}`;
    return window.location.href;
  };

  handleNonserviceableLocation = () => {
    this.setState({ isNonServiceableLocation: false });
  };

  openContactPermissionModal = () => {
    const { fields } = this.props;
    const errorMessage = t(fields.ManageContactPermissionWarning.value);
    this.setState({
      modalIsOpen: true, errorMessage, currentStep: 0, isManageContactPermission: true,
    });
  };

  render() {
    const {
      formData,
      valid,
      handleSubmit,
      submitSucceeded,
      dispatch,
      serviceLevelQuotes,
      putReduxServiceLevelCode,
      serviceLevelCode,
      serviceLevelApproved,
      isAuthenticated,
      billingAccounts,
      formSyncErrors,
      division,
    } = this.props;

    const { fields } = utils.isDisconnected ? mock : this.props;

    const componentFields = fields?.data?.datasource || fields || {};
    const canRateLink = componentFields?.canRateLink || null;
    const canRateHref = canRateLink?.jss?.value?.href
          || canRateLink?.value?.href
          || canRateLink?.href
          || '';
    const canRateTarget = canRateLink?.jss?.value?.target
          || canRateLink?.value?.target
          || canRateLink?.target
          || '_blank';

    const {
      accessorialsBase,
      services,
      currentStep,
      lastStep,
      reviewStep,
      accList,
      data,
      modalIsOpen,
      errorType,
      errorMessage,
      submitFailure,
      isProtectedAccount,
      isNonServiceableLocation,
      isManageContactPermission,
      fromContactId,
      toContactId,
      isWinterNonServiceableLocation,
      embargoErrorMessage,
      isEmbargoErrorMessageUpdated,
      getRatesError,
      shipperName,
      shipperPostalCode,
      consigneePostalCode,
      isWindows,
    } = this.state;

    const USQuote = (formData && formData.quoteType && formData.quoteType.name === QuoteTypes.USQuote);
    const DomesticQuote = (formData && formData.quoteType && formData.quoteType.name === QuoteTypes.Domestic);
    const Sameday = division === Divisions.Sameday.name;
    const commodities = utils.isDisconnected ? mock.fields.data.commoditiesItem : fields.data.commoditiesItem;
    const commodityList = { children: [...commodities.children] };
    if (formData
      && ((isCANPostal(formData.shipperPostalZipCode) && isUSZip(formData.consigneePostalZipCode))
      || (isUSZip(formData.shipperPostalZipCode) && isCANPostal(formData.consigneePostalZipCode)))) {
      commodityList.children = [...commodityList.children].filter((c) => c.enableForUsShipment.value === '1');
    }

    const accessorials = utils.isDisconnected ? mock.fields.data.accessorialsItem : fields.data.accessorialsItem;

    const printQuote = () => {
      const quoteNumber = data && data.quoteNumber;
      apiDownloadQuoteReport(quoteNumber);
    };

    const duplicateQuote = () => {
      window.location.href = `${routes.createQuote}?quoteNumber=${data && data.quoteNumber}`;
    };

    return (
      <div>
        {isAuthenticated && isWindows && canRateHref && (
        <CanRateLinkWrapper>
          <a
            href={canRateHref}
            target={canRateTarget}
            rel="noopener noreferrer"
          >
            {t('CanRateLink')}
          </a>
        </CanRateLinkWrapper>
        )}
        <Beforeunload onBeforeunload={() => "You'll lose your data!"} />
        <FormProgressBar current={currentStep} steps={this.steps} />
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={this.closeModal}
          style={ModalBoxStyle}
          contentLabel="Modal"
        >
          <CreateQuoteModals
            embargoErrorMessage={embargoErrorMessage}
            isEmbargoErrorMessageUpdated={isEmbargoErrorMessageUpdated}
            getRatesError={getRatesError}
            Sameday={Sameday}
            errorType={errorType}
            errorMessage={errorMessage}
            isWinterNonServiceableLocation={isWinterNonServiceableLocation}
            DomesticQuote={DomesticQuote}
            isManageContactPermission={isManageContactPermission}
            fields={fields}
            USQuote={USQuote}
            isProtectedAccount={isProtectedAccount}
            isNonServiceableLocation={isNonServiceableLocation}
            handleModalButtons={this.handleModalButtons}
            createQuoteFlag={this.state.createQuoteFlag}
          />
        </Modal>

        <SignupBanner loggedIn={isAuthenticated} />

        <FormContainer>

          <form onSubmit={handleSubmit(this.handleSubmit)}>

            <Step1
              formData={formData}
              step={currentStep}
              getServiceLevel={this.getServiceLevel}
              dispatch={dispatch}
              changeBillTo={this.changeBillTo}
              formName={formName}
              billingAccounts={billingAccounts}
              parentFields={fields}
              isLoggedIn={isAuthenticated}
              addressFieldsRef={this.addressFieldsRef}
              isNonServiceableLocation={this.handleNonserviceableLocation}
              openContactPermissionModal={this.openContactPermissionModal}
              fromContactId={fromContactId}
              shipperName={shipperName}
              shipperPostalCode={shipperPostalCode}
              consigneePostalCode={consigneePostalCode}
              toContactId={toContactId}
            />

            <Step2
              fields={null}
              formData={formData}
              step={currentStep}
              valid={valid}
              formName={formName}
              dispatch={dispatch}
              accessorialsList={accList}
              preExistingValuesExist={false}
              parentFields={fields}
              error={formSyncErrors}
              loggedIn={isAuthenticated}
              commoditiesList={commodityList}
              unitsList={unitsList}
            />

            <Step3
              formData={formData}
              step={currentStep}
              lastStep={lastStep}
              valid={valid}
              formName={formName}
              dispatch={dispatch}
              accessorialsList={accessorials}
              services={services}
              preExistingValuesExist={false}
              parentFields={fields}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              loggedIn={isAuthenticated}
            />

            <Step4
              accessorialsBase={accessorialsBase}
              formData={formData}
              quoteData={data}
              step={currentStep}
              lastStep={lastStep}
              valid={valid}
              editStepOne={this.editStepOne}
              editStepTwo={this.editStepTwo}
              editStepThree={this.editStepThree}
              serviceLevelQuotes={serviceLevelQuotes}
              quoteApproved={serviceLevelApproved}
              putReduxServiceLevelCode={putReduxServiceLevelCode}
              serviceLevelCode={serviceLevelCode}
              USQuote={USQuote}
              parentFields={fields}
              billingAccounts={billingAccounts}
              serviceLevels={serviceLevels}
            />

            <Step5
              isAuthenticated={isAuthenticated}
              formData={formData}
              isBasedOnAnExistingQuoteOrOrder={(formData && formData.quoteOrShipmentNumber)}
              formHasBeenSubmited={(submitSucceeded && (submitFailure === false))}
              quoteData={data}
              currentStep={currentStep}
              authenticated={isAuthenticated}
              serviceLevelQuotes={serviceLevelQuotes}
              quoteApproved={serviceLevelApproved}
              chosenServiceLevelCode={serviceLevelCode}
              USQuote={USQuote}
              parentFields={fields}
              billingAccounts={billingAccounts}
              actions={{
                gotoPreviousStep: this.prevStep,
                shipNow: this.handleShipNow,
                printQuote,
                duplicateQuote,
              }}
              createQuoteData={this.state.createQuoteData}
              serviceLevels={serviceLevels}
            />

            <NextPreviousButtons
              currentStep={currentStep}
              totalSteps={lastStep}
              reviewStep={reviewStep}
              isValid={valid}
              nextObj={{
                label: (currentStep === 3) ? t('RequestQuote') : t('Next'),
                action: this.nextStep,
                disabled: (!valid || isProtectedAccount || isNonServiceableLocation),
              }}
              previousObj={{
                label: t('Back'),
                action: this.prevStep,
              }}
              submitObj={{
                label: t('RequestQuote'),
              }}
            />

          </form>

          <QuestionsBlock />
        </FormContainer>
      </div>
    );
  }
}
export const postalValidateCall = (values, dispatch, props, fieldName, isAuthenticated) => {
  const {
    shipperAddress, consigneeAddress, shipperPostalZipCode, consigneePostalZipCode,
  } = values;

  const error = { ...props.asyncErrors, [fieldName]: undefined };
  let hasError = false;

  if (isAuthenticated === false) {
    if (shipperAddress && !isCanadianAddress(shipperAddress)) {
      return new Promise(() => {
        const error = { ...props.asyncErrors, shipperAddress: t('NoServiceOutsideCanada') };
        throw error;
      });
    }

    if (consigneeAddress && !isCanadianAddress(consigneeAddress)) {
      return new Promise(() => {
        const error = { ...props.asyncErrors, consigneeAddress: t('NoServiceOutsideCanada') };
        throw error;
      });
    }
  }

  const isAmerican = (postalcode) => {
    if (postalcode) {
      const code = postalcode.trim();
      const onlyNumbersOnPostalCode = /^[0-9]*$/g;
      return onlyNumbersOnPostalCode.test(code);
    }

    return false;
  };

  if (fieldName && fieldName.includes('Nickname')) {
    const addressFieldName = `${fieldName.split('Nickname')[0]}Address`;
    props.touch(addressFieldName); // turn on error messages
    return props.asyncValidate(values, dispatch, props, addressFieldName); // evaluate whether the address field will fail or not
  }

  // Check if at least one address is from Canada
  if (shipperPostalZipCode && consigneePostalZipCode) {
    const shipperIsAmerican = isAmerican(shipperPostalZipCode);
    const consigneeIsAmerican = isAmerican(consigneePostalZipCode);

    if (shipperIsAmerican && consigneeIsAmerican) {
      hasError = true;
      error.shipperAddress = t('OneAddressMustBeCanadian');
      error.consigneeAddress = t('OneAddressMustBeCanadian');
      error.shipperPostalZipCode = t('OnePostalMustBeCanadian');
      error.consigneePostalZipCode = t('OnePostalMustBeCanadian');
    }
  }

  // Check if shipper and consignee addresses are different
  if (shipperAddress && consigneeAddress) {
    if (shipperAddress === consigneeAddress) {
      hasError = true;
      error.shipperAddress = t('NoSameAddress');
      error.consigneeAddress = t('NoSameAddress');
    }
  }

  if (!hasError) {
    error.shipperAddress = undefined;
    error.consigneeAddress = undefined;
    error.shipperPostalZipCode = undefined;
    error.consigneePostalZipCode = undefined;
  }

  return new Promise(() => { throw error; });
};

CreateQuoteForm = reduxForm({
  form: formName, // a unique identifier for this form
  initialValues,
  validate: measurementValidate, // <--- validation function given to redux-form
  asyncValidate: addressValidation,
  asyncBlurFields: ['consigneeAddress', 'shipperAddress', 'consigneeNickname', 'shipperNickname'],
  asyncChangeFields: ['shipperPostalZipCode', 'consigneePostalZipCode'],
})(CreateQuoteForm);

CreateQuoteForm.propTypes = {
  fields: PropTypes.object,
  formData: PropTypes.object,
  valid: PropTypes.bool,
  formSyncErrors: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitSucceeded: PropTypes.bool,
  dispatch: PropTypes.func,
  serviceLevelQuotes: PropTypes.array,
  putReduxServiceLevelCode: PropTypes.func,
  serviceLevelCode: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  putReduxServiceLevelQuotes: PropTypes.func,
  serviceLevelApproved: PropTypes.bool,
  putReduxServiceLevelApproved: PropTypes.func,
  billingAccounts: PropTypes.array,
  division: PropTypes.string,
  userEmail: PropTypes.string,
  userId: PropTypes.string,
  addPageLoader: PropTypes.func,
  removePageLoader: PropTypes.func,
  putReduxAllCompanies: PropTypes.func,
  putReduxAllContacts: PropTypes.func,
  initialValues: PropTypes.any,
  userName: PropTypes.string,
};

const mstp = (state) => ({
  formData: getFormValues(formName)(state),
  formSyncErrors: getFormSyncErrors(formName)(state),
  initialValues: getFormInitialValues('CreateQuoteForm')(state),
  serviceLevelQuotes: state.user.serviceLevelQuotes,
  serviceLevelCode: state.user.serviceLevelCode,
  serviceLevelApproved: state.user.serviceLevelApproved,
  isAuthenticated: state.profile.isAuthenticated,
  billingAccounts: state.profile.billingAccounts,
  division: state.profile.division,
  userEmail: state.profile.email,
  userId: state.profile.userId,
  isLoading: state.general.isLoading,
  userName: state.profile.fullName,
});

const mdtp = (dispatch) => ({
  putReduxAllContacts: (allContacts) => dispatch(putReduxAllContacts(allContacts)),
  putReduxAllCompanies: (allCompanies) => dispatch(putReduxAllCompanies(allCompanies)),
  putReduxServiceLevelQuotes: (serviceLevelQuotes) => dispatch(putReduxServiceLevelQuotes(serviceLevelQuotes)),
  putReduxServiceLevelCode: (serviceLevelCode) => dispatch(putReduxServiceLevelCode(serviceLevelCode)),
  putReduxServiceLevelApproved: (serviceLevelApproved) => dispatch(putReduxServiceLevelApproved(serviceLevelApproved)),
  addPageLoader: () => dispatch(addPageLoader()),
  removePageLoader: () => dispatch(removePageLoader()),
});

export default connect(mstp, mdtp)(CreateQuoteForm);
